import {Flex, message, Typography} from 'antd'
import TextArea from "antd/es/input/TextArea"
import {AdUnitBean} from "common/api/api.ts"
import {env} from "common/env"
import {Link} from "react-router-dom"

const {Text} = Typography

const AdUnitCode = ({agencyId, adUnit}: { agencyId: string, adUnit: AdUnitBean }) => {

    const adUnitTag = `<script async src="{ASTERIOTAG_URL}"></script>
<div id="{AGENCY_ID}-adunit-{ADUNIT_ID}"></div>
<script id="{AGENCY_ID}-script-{ADUNIT_ID}">
    var asteriotag = asteriotag || {};
    asteriotag.cmd = asteriotag.cmd || [];
    asteriotag.cmd.push(function () {
        asteriotag.pageview('{AGENCY_ID}', '{ADUNIT_TOKEN}', '{AGENCY_ID}-adunit-{ADUNIT_ID}');
    });
</script>`

    function getHTMLTag() {
        return adUnitTag
            .replace(/{ASTERIOTAG_URL}/g, env.asteriotagUrl)
            .replace(/{AGENCY_ID}/g, agencyId || 'UNKNOWN_AGENCY')
            .replace(/{ADUNIT_ID}/g, adUnit.id?.toString() || 'UNKNOWN_ADUNIT_ID')
            .replace(/{ADUNIT_TOKEN}/g, adUnit.token || 'UNKNOWN_ADUNIT_TOKEN')
    }

    function getPrebidTag() {
        let endpoint = ''
        if (env.bidder && env.bidder.length > 10 && env.bidder.indexOf('bid.asterio.ai') == -1) {
            endpoint = ',\n\tendpoint: \'' + env.bidder + '/prebid/bid\''
        }

        return `{
    bidder: 'asterio',
    params: {
        adUnitToken: '${adUnit.token}'${endpoint}
    }
}`
    }

    function copy(code) {
        navigator.clipboard.writeText(code)
        message.success("Copied", 0.65)
        return false
    }

    return <>
        <Flex justify="space-between">
            <Text style={{fontSize: 16}}>Inject this code to show creatives directly on the page:</Text>
            <Text><Link to="#" onClick={() => copy(getHTMLTag())}>Copy</Link></Text>
        </Flex>
        <TextArea readOnly style={{resize: "none"}} value={getHTMLTag()} rows={6}></TextArea>

        <br/><br/>

        <Flex justify="space-between">
            <Text style={{fontSize: 16}}>Or use this code for Prebid.js framework:</Text>
            <Text><Link to="#" onClick={() => copy(getPrebidTag())}>Copy</Link></Text>
        </Flex>
        <TextArea readOnly style={{resize: "none"}} value={getPrebidTag()} rows={6}></TextArea>
        <Text style={{fontSize: 12}}>Prebid.js adapter help: </Text>
        <Link style={{fontSize: 12}} target="_blank" to="https://docs.prebid.org/dev-docs/bidders/asterio.html">click here</Link>
    </>
}

export default AdUnitCode